!(function (t) {
  "use strict";
  function e(t, e, s, r) {
    if ("a" === s && !r) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !r : !e.has(t))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === s ? r : "a" === s ? r.call(t) : r ? r.value : e.get(t);
  }
  "function" == typeof SuppressedError && SuppressedError;
  const s = (t) => {
      let e;
      const s = new Set(),
        r = (t, r) => {
          const n = "function" == typeof t ? t(e) : t;
          if (!Object.is(n, e)) {
            const t = e;
            (e = (null != r ? r : "object" != typeof n || null === n) ? n : Object.assign({}, e, n)),
              s.forEach((s) => s(e, t));
          }
        },
        n = () => e,
        i = {
          setState: r,
          getState: n,
          getInitialState: () => o,
          subscribe: (t) => (s.add(t), () => s.delete(t)),
          destroy: () => {
            console.warn(
              "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.",
            ),
              s.clear();
          },
        },
        o = (e = t(r, n, i));
      return i;
    },
    r = (t) => (t ? s(t) : s);
  var n;
  (window.Shopify = window.Shopify || {}),
    window.Shopify.formatMoney ||
      (window.Shopify.formatMoney = function (t, e) {
        let s = "";
        const r = /\{\{\s*(\w+)\s*\}\}/,
          n = e || window.Shopify.money_format || "";
        function i(t, e) {
          return void 0 === t ? e : t;
        }
        function o(t, e, s, r) {
          var n;
          if (((e = i(e, 2)), (s = i(s, ",")), (r = i(r, ".")), isNaN(t) || null == t)) return "0";
          const o = (t = (t / 100).toFixed(Number(e) + 1).slice(0, -1)).split(".");
          return (
            (null === (n = o[0]) || void 0 === n ? void 0 : n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s)) +
            (o[1] ? r + o[1] : "")
          );
        }
        "string" == typeof t && (t = t.replace(".", ""));
        const a = n.match(r);
        if (a) {
          switch (a[1]) {
            case "amount":
              s = o(t, 2, ",", ".");
              break;
            case "amount_no_decimals":
              s = o(t, 0, ",", ".");
              break;
            case "amount_with_comma_separator":
              s = o(t, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              s = o(t, 0, ".", ",");
              break;
            case "amount_with_apostrophe_separator":
              s = o(t, 2, "'", ".");
              break;
            case "amount_no_decimals_with_space_separator":
              s = o(t, 0, " ", ".");
              break;
            case "amount_with_space_separator":
              s = o(t, 2, " ", ",");
              break;
            case "amount_with_period_and_space_separator":
              s = o(t, 2, " ", ".");
              break;
            default:
              s = "";
          }
          return n.replace(r, s);
        }
        return "";
      });
  class Component extends HTMLElement {
    constructor() {
      super(),
        n.set(this, (t) => {
          var e;
          if (!t) return {};
          try {
            return null !== (e = JSON.parse(t)) && void 0 !== e ? e : {};
          } catch (t) {
            return {};
          }
        }),
        (this.getState = (t) => {
          const e = this.store.getState();
          return t ? e[t] : e;
        }),
        (this.setState = (t, e) => {
          this.store.setState({ [t]: e });
        }),
        (this.subscribeState = (t) => this.store.subscribe(t)),
        (this.subscribe = this.subscribeState),
        (this.getStoreContext = () => this.context),
        (this.getContext = (t) => {
          const e = this.context.getState();
          return t ? e[t] : e;
        }),
        (this.setContext = (t, e) => {
          this.context.setState({ [t]: e });
        }),
        (this.subscribeContext = (t) => this.context.subscribe(t));
      const t = this.getAttribute("c-data"),
        s = this.getAttribute("c-context");
      if (((this.store = r(() => e(this, n, "f").call(this, t))), s))
        this.context = r(() => e(this, n, "f").call(this, s));
      else {
        const t = this.closest("[c-context]");
        t && t.getStoreContext ? (this.context = t.getStoreContext()) : (this.context = r(() => ({})));
      }
    }
  }
  (n = new WeakMap()), (t.Component = Component);

  window.Component = Component;
})({});
